import React from 'react';

const Ellipse1757 = props => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="7" cy="7" r="7" fill="#C1188B" />
  </svg>
);

export default Ellipse1757;
